/**
 * Compact filter chrome for the notifications side rail: Active / All / Reviewed
 * on the left, expand/collapse for scope and activity overlays on the right.
 */
import { useState } from "react";
import { ChevronDown, ChevronUp, SlidersHorizontal } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useFeed } from "@/context/FeedContext";
import { countExtraFeedFilters } from "./feedKaiFilters";
import { FeedFilterBar } from "./FeedFilterBar";
import { FeedReviewStatusToggle } from "./FeedReviewStatusToggle";

export function FeedRailFilterControls({ className }: { className?: string }) {
  const { filters } = useFeed();
  const extraCount = countExtraFeedFilters(filters);
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={cn("feed-rail-filters", className)}>
      <div className="feed-rail-toolbar">
        <FeedReviewStatusToggle className="min-w-0 shrink" />
        <button
          type="button"
          aria-expanded={expanded}
          aria-label={
            extraCount > 0
              ? expanded
                ? `Hide activity filters, ${extraCount} active`
                : `Show activity filters, ${extraCount} active`
              : expanded
                ? "Hide activity filters"
                : "Show activity filters"
          }
          onClick={() => setExpanded((open) => !open)}
          className={cn(
            "feed-rail-filters-toggle",
            (expanded || extraCount > 0) && "feed-rail-filters-toggle--active",
          )}
        >
          <SlidersHorizontal className="size-3.5 shrink-0" aria-hidden />
          {extraCount > 0 && (
            <Badge
              variant="secondary"
              className="h-4 min-w-4 justify-center px-1 text-[0.625rem] tabular-nums"
            >
              {extraCount}
            </Badge>
          )}
          {expanded ? (
            <ChevronUp className="size-3.5 shrink-0 opacity-70" aria-hidden />
          ) : (
            <ChevronDown className="size-3.5 shrink-0 opacity-70" aria-hidden />
          )}
        </button>
      </div>

      {expanded && (
        <FeedFilterBar hideReviewStatus compactScope className="w-full min-w-0" />
      )}
    </div>
  );
}
